import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
        selectedLangId : +Cookies.get('selectedLangId') || null,
        isAddToCartBtnVisible : false,
        serverTimestamp : '',
        currencies : {},
        langs : [],
        placeLangs : [],
        productTypes : [],
        cart : {
            items : [],
        },
    },
    mutations : {
        setCartItems (state, items = []) {
            state.cart.items = items;
        },
        setProductTypes (state, items = []) {
            state.productTypes = items;
        },
        setLangs (state, items = []) {
            state.langs = items;
        },
        setCurrencies (state, items = []) {
            state.currencies = items;
        },
        setPlaceLangs (state, items = []) {
            state.placeLangs = items;
        },
        setSelectedLangId (state, langId) {
            state.selectedLangId = langId;
            Cookies.set('selectedLangId', langId);
        },
        setServerTimestamp (state, value) {
            state.serverTimestamp = value;
        },
        setAddToCartBtnVisible (state, val) {
            state.isAddToCartBtnVisible = !!val;
        },
    },
    actions : {
        loadCartData ({ commit }) {
            return new Promise(resolve => {
                fetch('/api/v1/cart/')
                    .then(res => res.json())
                    .then(res => {
                        if (res) {
                            commit('setCartItems', res.items || []);
                        }
                        resolve(res);
                    });
            });
        },
        loadInitData ({ commit }) {
            return new Promise(resolve => {
                fetch('/api/v1/init/')
                    .then(res => res.json())
                    .then(res => {
                        if (res.langs) {
                            commit('setLangs', res.langs || []);
                        }
                        if (res.currencies) {
                            commit('setCurrencies', res.currencies || {});
                        }
                        if (res.placeLangs) {
                            commit('setPlaceLangs', res.placeLangs || []);
                        }
                        if (res.selectedLangId) {
                            commit('setSelectedLangId', res.selectedLangId || []);
                        }
                        if (res.timestamp) {
                            commit('setServerTimestamp', res.timestamp);
                        }
                        if (res.productTypes) {
                            commit('setProductTypes', res.productTypes);
                        }
                        if (res.isAddToCartBtnVisible) {
                            commit('setAddToCartBtnVisible', res.isAddToCartBtnVisible);
                        }
                        resolve(res);
                    });
            });
        },
    },
})
